<div class="description-consumer">
  <div class="sensor-list-tab">
    <mat-tab-group [@.disabled]="true" [selectedIndex]="0" *ngIf="isDetailMode">
      <mat-tab>
        <ng-template mat-tab-label>
          <div class="tab-container">
            <span>{{ 'module.energyMap.descriptionComponent.buildingDetailsTabHeaderText' | translate }}</span>
          </div>
        </ng-template>
        <app-building-details [data]="building$ | async" (editMode)="editBuildingDetails()"></app-building-details>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <div class="tab-container">
            <span>{{ 'module.energyMap.descriptionComponent.meterListTabHeaderText' | translate }}</span>
          </div>
        </ng-template>
        <app-meter-list [data]="building$ | async" (editMode)="editBuildingDetails()"></app-meter-list>
      </mat-tab>
      <mat-tab *ngIf="!!authService.permissions.SENSOR_DATA">
        <ng-template mat-tab-label>
          <div class="tab-container">
            <span>{{ 'module.energyMap.descriptionComponent.sensorsListTabHeaderText' | translate }}</span>
          </div>
        </ng-template>
        <div class="sensor-container">
          <app-sensor-list [sensors]="sensors" [routerParams]="sensorRouterParams"></app-sensor-list>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>

  <div class="bottom-part" *ngIf="isDetailMode">
    <div class="options">
      <button
        type="button"
        class="btn btn-white -border"
        id="efficiencyAnalysis"
        (click)="displayEfficiencyAnalysisWizard()"
        *ngIf="efficiencyAnalysisService.hasEfficiencyAnalysis && !!authService.permissions.EFFICIENCY_ANALYSIS"
      >
        {{ 'module.energyMap.descriptionComponent.navigationEfficiencyAnalyzeText' | translate }}
      </button>
      <button
        type="button"
        class="btn btn-primary -border"
        *ngIf="!!authService.permissions.ENERGY_GUARD && data.isMunicipalityEnergyGuardLicensed"
        [ngSwitch]="data.isBuildingEnergyGuardLicensed"
        (click)="gotoMeterListPage(building.connectionObjectNumber, data.isBuildingEnergyGuardLicensed)"
        [ngClass]="{ unlicensed: !data.isBuildingEnergyGuardLicensed }"
      >
        <span *ngSwitchCase="true">
          {{ 'module.energyGuard.common.headerText' | translate }}
        </span>

        <span *ngSwitchCase="false">
          {{ 'module.energyGuard.common.secondaryHeaderText' | translate }}
        </span>
      </button>

      <button
        type="button"
        class="btn btn-white -border"
        *ngIf="!!authService.permissions.METER_READING_SPACE"
        (click)="goToRoute(building.connectionObjectNumber, 'messdaten/zählerstand')"
      >
        {{ 'module.energyMap.descriptionComponent.navigationMeterReadingText' | translate }}
      </button>
      <button
        type="button"
        class="btn btn-white -border"
        *ngIf="!!authService.permissions.ENERGY_DATA"
        (click)="goToRoute(building.connectionObjectNumber, 'messdaten/energiedaten')"
      >
        {{ 'module.energyMap.descriptionComponent.navigationVisualizatonText' | translate }}
      </button>
    </div>
  </div>

  <div class="edit" *ngIf="isEditMode || isEditLocation">
    <label class="header-label">Gebäudedetails bearbeiten</label>
    <div *ngIf="isEditMode">
      <div class="edit-mode" *ngIf="isEditMode">
        <div class="top-part">
          <label class="error-message" *ngIf="errorMessage !== ''"> {{ errorMessage }}</label>
          <div class="identifier" *ngIf="isEditMode">Objekttyp</div>
          <div class="btn-group" dropdown *ngIf="isEditMode">
            <mat-form-field class="dropdown-toggle" floatLabel="never">
              <mat-label> {{ building?.buildingType ? building.buildingType.name : 'Wähle Gebäudeart' }}</mat-label>
              <mat-select
                matNativeControl
                required
                panelClass="my-select-panel-class"
                *ngIf="!!authService.permissions.BUILDING_TYPE || !!authService.permissions.BUILDING_TYPE_UPDATE"
                [disabled]="!!!authService.permissions.BUILDING_TYPE_UPDATE"
              >
                <mat-option
                  role="menuitem"
                  *ngFor="let buildingType of buildingTypes; trackBy: trackByFn"
                  value="{{ buildingType.id }}"
                  href="javascript:void(0);"
                  (click)="setType(buildingType)"
                >
                  {{ buildingType.name }}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </div>
          <div class="validator" *ngIf="isEditMode" [ngClass]="building?.buildingType ? 'success' : 'error'">
            <span [ngClass]="building?.buildingType ? 'fa fa-check-circle' : ' fa fa-info-circle'"> </span>
            {{
              (building?.buildingType
                ? 'module.energyMap.descriptionComponent.objectTypeWithValueText'
                : 'module.energyMap.descriptionComponent.objectTypeNullText'
              ) | translate
            }}
          </div>
          <div class="identifier" *ngIf="isEditMode">Objektname</div>
          <div class="header">
            <input
              *ngIf="isEditMode"
              class="name-input"
              [(ngModel)]="building.name"
              maxlength="250"
              [disabled]="!!!authService.permissions.BUILDING_TYPE_UPDATE"
            />
          </div>
          <div class="location">
            <div class="address">
              <div class="identifier">{{ 'module.energyMap.descriptionComponent.address' | translate }}</div>
              <div class="value">{{ building.street.concat(' ', building.houseNumber || '') }}</div>
              <div class="value">{{ building.zipCode.concat(' ', building.district || '') }}</div>
            </div>
            <div class="coordinates">
              <div class="identifier">
                GPS Standort
                <span class="fa fa-history" (click)="openHistoryDialog()" aria-hidden="true"></span>
              </div>
              <div class="value">
                BREITE <span class="value">{{ building?.latitude }}</span>
              </div>
              <div class="value">
                LÄNGE <span class="value">{{ building?.longitude }}</span>
              </div>
            </div>
          </div>
          <div class="validator" *ngIf="isEditMode" [ngClass]="building?.latitude ? 'success' : 'error'">
            <span [ngClass]="building?.latitude ? 'fa fa-check-circle' : 'fa fa-info-circle'"> </span>
            {{
              (building?.latitude ? 'module.energyMap.descriptionComponent.GPSWithValueText' : 'module.energyMap.descriptionComponent.GPSNullText') | translate
            }}
          </div>
          <button
            class="btn btn-outline-primary save-loc-btn"
            *ngIf="isEditMode && (!!authService.permissions.BUILDING_TYPE_UPDATE || !!authService.permissions.BUILDING_NOTICES_UPDATE)"
            (click)="editLocation()"
          >
            <span class="btn-text">Standort ändern</span>
          </button>
        </div>

        <div class="identifier">Kommentar</div>
        <textarea
          class="description-input"
          rows="3"
          cols="50"
          *ngIf="(isEditMode && !!authService.permissions.BUILDING_NOTICES) || !!authService.permissions.BUILDING_NOTICES_UPDATE"
          [disabled]="!!!authService.permissions.BUILDING_NOTICES_UPDATE"
          [(ngModel)]="building.description"
          placeholder="{{ 'module.energyMap.descriptionComponent.commentPlaceholderText' | translate }}"
          maxlength="250"
        >
        </textarea>

        <div class="action-btns">
          <button
            (click)="save()"
            class="btn save-btn"
            [disabled]="!hasBuildingId"
            *ngIf="isEditMode && (!!authService.permissions.BUILDING_TYPE_UPDATE || !!authService.permissions.BUILDING_NOTICES_UPDATE)"
          >
            <span class="fa fa-save" aria-hidden="true"></span>
            <span class="btn-text">Speichern</span>
          </button>
          <button
            (click)="back()"
            class="btn btn-outline-secondary back-btn"
            *ngIf="isEditMode && (!!authService.permissions.BUILDING_TYPE_UPDATE || !!authService.permissions.BUILDING_NOTICES_UPDATE)"
          >
            <span class="btn-text">Abbrechen</span>
          </button>
        </div>
      </div>
    </div>

    <div *ngIf="isEditLocation">
      <app-edit-location [building]="building" (closeEvent)="closeEditLocation()"></app-edit-location>
    </div>
  </div>
</div>
